import type { ReactElement } from 'react';

import { ContentContainer } from '../../../components/layout/contentContainer';
import { HeaderContainer } from '../../../components/layout/headerContainer';
import { OfflineChatGratitudeContainer } from '../../../components/offlineChat/offlineChatGratitudeContainer';
import { OfflineChatGratitudeHeader } from '../../../components/offlineChat/offlineChatGratitudeHeader';

const OfflineChatGratitude = (): ReactElement => (
	<>
		<HeaderContainer>
			<OfflineChatGratitudeHeader />
		</HeaderContainer>
		<ContentContainer>
			<OfflineChatGratitudeContainer />
		</ContentContainer>
	</>
);

export { OfflineChatGratitude };
